/** 分类筛选：查询未匹配人设类目的成员 */
export const ATMOSPHERE_UNCATEGORIZED_FILTER = "__UNCATEGORIZED__";

/** 历史数据中的旧未分类名称 */
export const LEGACY_UNMATCHED_ATMOSPHERE_CATEGORY_NAME = "未分组";
